import { render, staticRenderFns } from "./MemberCenter.vue?vue&type=template&id=74521acb&scoped=true"
import script from "./MemberCenter.vue?vue&type=script&lang=js"
export * from "./MemberCenter.vue?vue&type=script&lang=js"
import style0 from "./MemberCenter.vue?vue&type=style&index=0&id=74521acb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74521acb",
  null
  
)

export default component.exports